import * as axios from 'axios'
import qs from 'qs'

import { authHeader } from '../helpers/auth-header'
import { history } from '../helpers/history'
import { AUTH_SERVER_URL } from '../helpers/constants'
import { ACCESS_TOKEN_KEY, REFRESH_TOKEN_KEY, SESSION_BY_ID } from '../constants/token'

const api = SERVICE => axios.create({ baseURL: SERVICE })

let instanceService = {
  instance: (SERVICE) => {
    let inst = api(SERVICE)
    wrapInstance(inst)
    return inst
  },

  isChangeRefreshToken: false,
  newRequest: null
}

const wrapInstance = instance => {
  instance.interceptors.request.use((config) => {
    config.headers.Authorization = authHeader()
    const useCashbox = JSON.parse(localStorage.getItem(SESSION_BY_ID))

    if (useCashbox) {
      config.headers.USE_CASH_BOX = useCashbox.value;
    }

    return config
  })

  instance.interceptors.response.use((response) => {
    // const {statusText, status, data} = response
    return response
  }, handleError)
}

const changeRefreshToken = () => {
  const newRequest = api(`${AUTH_SERVER_URL}/oauth/token`)
  instanceService.isChangeRefreshToken = true
  const refreshToken = JSON.parse(localStorage.getItem(REFRESH_TOKEN_KEY))
  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/x-www-form-urlencoded' },
    data: qs.stringify({
      refresh_token: refreshToken,
      grant_type: 'refresh_token'
    }),
    auth: {
      username: 'fNZDSWid85UC1YhV',
      password: 'PytZWmpYz6UrPHKmkHiZxwMv'
    }
  }

  instanceService.newRequest = newRequest(options)
    .then((response) => {
      localStorage.setItem(ACCESS_TOKEN_KEY, JSON.stringify(response.data.access_token))
      localStorage.setItem(REFRESH_TOKEN_KEY, JSON.stringify(response.data.refresh_token))
      instanceService.isChangeRefreshToken = false
    })
    .catch(error => {
      if(error.response.data.error ==='invalid_grant') {
        localStorage.clear()
        instanceService.isChangeRefreshToken = false
        history.push('/')
        window.location.reload()
      }
      return Promise.reject(error)
    })
}

const handleError = error => {
  const {
    config,
    response: { status, data },
  } = error

  if (status === 401 && config.url !== '/user/oauth/token'
      && data.error_description !== 'Expired attorney end date'
      && data.error_description !== 'User is disabled'
      && data.error_description !== "User with current credentials already exists it system") {
    if (!instanceService.isChangeRefreshToken) {
      changeRefreshToken()
      return instanceService.newRequest
        .then(() => {
          config.headers.Authorization = authHeader()
          return axios.request(config)
        })
        .catch(error => Promise.reject(error))
    } else {
      return instanceService.newRequest
        .then(() => {
          config.headers.Authorization = authHeader()
          return axios.request(config)
        })
        .catch(error => Promise.reject(error))
    }
  }

  return Promise.reject(error)
}

export default instanceService